package crashreporting

actual fun createCrashReporter(config: CrashReporterConfig): CrashReporter =
    fallbackCrashReporter(config)
